import React from "react";
import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Autocomplete,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";

// Map filter values to backend status codes
const filterOptions = [
  { value: "all", label: "All", code: null },
  { value: "pending", label: "Pending", code: "P" },
  { value: "applied", label: "Applied", code: "A" },
  { value: "waiting", label: "Waiting", code: "W" },
  // Not its own status code - the backend maps this to status "W" plus
  // queuedForProcessing: true (see routes/paymentstatus.js /fetch-links).
  { value: "underprocess", label: "Under Process", code: "W" },
  { value: "success", label: "Success", code: "S" },
  { value: "failed", label: "Failed", code: "F" },
  { value: "rejected", label: "Rejected", code: "R" },
];

export default function PaymentFilter({
  filterStatus,
  onFilterChange,
  filteredCount,
  totalCount,
  pocs = [],
  filterPoc,
  onPocChange,
  overdueOnly,
  onOverdueChange,
  overdueSort,
  onOverdueSortChange,
}) {
  const handleChange = (event) => {
    const selectedValue = event.target.value;
    console.log("Filter changed to:", selectedValue); // Debug log
    onFilterChange(selectedValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        // px: 2,
        // py: 1,
        // borderBottom: "1px solid #e0e0e0",
        // backgroundColor: "#f8f9fa",
      }}
    >
      <FormControl
        sx={{ minWidth: 140 }}
      >
        <Select
          value={filterStatus}
          onChange={handleChange}
          size="small"
          sx={{
            "& .MuiSelect-select": {
              py: 0.75,
            },
            fontSize: 12
          }}
        >
          {filterOptions.map((option, index) => (
            <MenuItem
              key={option.value}
              value={option.value}
              sx={{
                py: 1,
                borderBottom:
                  index === filterOptions.length - 1
                    ? "none"
                    : "1px solid #e0e0e0",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="body2">{option.label}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Autocomplete
        size="small"
        sx={{ minWidth: 200 }}
        options={pocs}
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        value={pocs.find((p) => p.id === filterPoc) || null}
        onChange={(e, value) => onPocChange(value?.id || "")}
        renderInput={(params) => (
          <TextField {...params} placeholder="All POCs" sx={{ fontSize: 12 }} />
        )}
      />

      <FormControlLabel
        sx={{ mr: 0 }}
        control={
          <Checkbox
            size="small"
            checked={overdueOnly}
            onChange={(e) => onOverdueChange(e.target.checked)}
          />
        }
        label={<Typography variant="body2">Overdue</Typography>}
      />

      {overdueOnly && (
        <Tooltip title={overdueSort === "desc" ? "Due date: Newest first" : "Due date: Oldest first"}>
          <IconButton
            size="small"
            onClick={() => onOverdueSortChange(overdueSort === "desc" ? "asc" : "desc")}
          >
            {overdueSort === "desc" ? (
              <ArrowDownward fontSize="small" />
            ) : (
              <ArrowUpward fontSize="small" />
            )}
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
}